export default {
  today: {
    de: 'Heute',
  },
  yesterday: {
    de: 'Gestern',
  },
  'this week': {
    de: 'Diese Woche',
  },
  'this month': {
    de: 'Diesen Monat',
  },
  // Schemas
  'https://codemeta.de/schemas/callback': {
    de: 'Rückruf',
  },
  'https://codemeta.de/schemas/visitor': {
    de: 'Besucher',
  },
  "PRF extension was requested but is not supported by the authenticator": {
    de: "Die PRF-Erweiterung wird vom Authentifikator nicht unterstützt",
  },
};
